const Content = {
  'homepage': {
    'line1': 'Research creates a laboratory to try new ideas',
    'line2': 'to push the envelope',
    'line3': 'and',
    'line4': 'to challenge conventional thinking.'
  }
};

export { Content };
